import { render, staticRenderFns } from "./ReferenceImageDialog.vue?vue&type=template&id=8d455078&scoped=true&"
import script from "./ReferenceImageDialog.vue?vue&type=script&lang=js&"
export * from "./ReferenceImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceImageDialog.vue?vue&type=style&index=0&id=8d455078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d455078",
  null
  
)

export default component.exports